import { useTheme as useMuiTheme } from '@mui/material/styles'

/**
 * Custom hook to access Intelibly theme in shared components
 *
 * @returns {Object} MUI theme object
 *
 * @example for further simplification of theme palette access
 * const theme = useTheme()
 * const primaryColor = theme.palette.primary.main
 * const secondaryColor = theme.palette.secondary.main
 */
export const useTheme = useMuiTheme
